export const ADMIN_DEEP_LINK_QUERY_KEYS = [
  'companyId',
  'accountid',
  'type',
  'tab',
  'productId',
  'catalogId',
];

export const ADMIN_DETAIL_QUERY_KEYS = ['productId', 'catalogId'];

export function omitQueryKeys(query, keys) {
  const next = { ...(query || {}) };
  keys.forEach((key) => {
    delete next[key];
  });
  return next;
}

export function replaceRouteQuery(router, query) {
  if (!router || !router.currentRoute) return Promise.resolve();
  return router.replace({
    path: router.currentRoute.path,
    query,
  }).catch(() => {});
}

/** 关闭管理端侧栏时清掉 deep-link 参数，避免刷新后再次自动打开 */
export function clearAdminDeepLinkFromRoute(router) {
  const next = omitQueryKeys(router.currentRoute.query, ADMIN_DEEP_LINK_QUERY_KEYS);
  return replaceRouteQuery(router, next);
}

/** 关闭产品/目录详情时仅清掉 productId / catalogId */
export function clearAdminDetailFromRoute(router) {
  const next = omitQueryKeys(router.currentRoute.query, ADMIN_DETAIL_QUERY_KEYS);
  return replaceRouteQuery(router, next);
}
